<template>
  <div v-if="selectedBusinessId && selectedBranchId && selectedFloorId">
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      :showBusinessSelector="false"
      :showBranchSelector="false"
      @update:searchQuery="searchQuery = $event"
    />

    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" md="8" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title" v-if="selectedBusinessId && selectedBranchId && selectedFloorId">
                  Floor : {{ selectedFloor && selectedFloor.locales[0].name }} - Tables
                </h4>
              </div>
            </div>

            <div class="iq-card-body">
              <b-table
                class="table b-table table-striped"
                :items="filteredLocalizedItems"
                :fields="columns.map(col => col.prop)"
                striped
                ref="table"
              >
                <template v-for="column in columns" #[`cell(${column.prop})`]="data" >
                  <span v-if="!column.isAction">
                    {{ data.item[column.prop] || column.default }}
                  </span>

                  <span v-else>
                    <div class="d-flex justify-content-around">
                      <b-button @click="editMenu(data.item)"variant=" iq-bg-success"  size="sm" >
                        <i class="ri-ball-pen-fill m-0"></i>
                      </b-button>
                      <b-button @click="handleDelete(data.item)" v-b-modal.modal-delete variant=" iq-bg-danger" size="sm" >
                        <i class="ri-delete-bin-line m-0"></i>
                      </b-button>
                    </div>
                  </span>
                </template>
              </b-table>
              <div
                class="mt-3 d-flex justify-content-center"
                v-if="!this.searchQuery"
              >
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="TablesList"
                />
              </div>
              <EmptySearchMessage
                v-if="searchQuery && filteredLocalizedItems.length <= 0"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4" class="">
          <div class="iq-card ">
            <div></div>
            <Create
              v-if="showAdd"
              :isInList="true"
              @onSubmit="TablesList()"
              :branchId="selectedBranchId"
              :businessId="selectedBusinessId"
              :floorId="selectedFloorId"
            />

            <Edit
              v-if="!showAdd && editModel"
              :isInList="true"
              @onSubmit="TablesList()"
              :model="editModel"
              :showAdd="showAdd"
              @showAddChanged="updateShowAddState"
              :branchId="selectedBranchId"
              :businessId="selectedBusinessId"
              :floorId="selectedFloorId"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- this modal will be shown after clicking the delete button -->
    <b-modal
      id="modal-delete"
      title="Confirm Delete"
      @ok="confirmDelete"
      ok-title="Yes, Delete"
      cancel-title="Cancel"
      ok-variant="danger"
      centered
    >
      <p>Are you sure you want to delete this item?</p>
    </b-modal>
    <!-- end of modal -->
  </div>
</template>

<script>
import Create from "./Create.vue";
import TableConfiguration from "./TableConfiguration";
import Edit from "./Edit.vue";
import { core } from "@/config/pluginInit";
import { deleteTable, getTableData } from "@/API/TablesAPIs";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "TablesList",
  mixins: [TableConfiguration],
  components: {
    Create,
    Edit,
    SearchFilters,
    EmptySearchMessage
  },
  data() {
    return {
      items: [],
      searchQuery: "",
      selectedBusinessId: null,
      selectedBranch: null,
      selectedBranchId: null,
      selectedFloorId: null,
      deletedItem: null,
      showAdd: true,
      editModel: null,
      showSearchBox: true
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },

    filteredLocalizedItems() {
      return this.items
        .map(item => {
          const localizedData =
            item.locales.find(locale => locale.locale === this.currentLocale) ||
            item.locales[0];
          return {
            ...item,
            name: localizedData.name || "",
            description: localizedData.description || ""
          };
        })
        .filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    },

    selectedFloor() {
      if (
        this.selectedBusinessId &&
        this.$store.state.User.user.business &&
        this.$store.state.User.user.business.length > 0
      ) {
        return this.$store.state.User.user.business
          .filter(r => r.id === this.selectedBusinessId)[0]
          .branches.filter(r => r.id === this.selectedBranchId)[0]
          .floors.filter(r => r.id === this.selectedFloorId)[0];
      }
      return null;
    }
  },

  async mounted() {
    core.index();
    this.updateSelectedIds();

    if (
      this.selectedBusinessId &&
      this.selectedBranchId &&
      this.selectedFloorId
    ) {
      await this.TablesList();
    } else {
      console.warn("Missing required IDs for business, branch, or floor.");
    }
  },
  methods: {
    updateSelectedIds() {
      this.selectedBusinessId = parseInt(this.$route.query.rid) || null;
      this.selectedBranchId = parseInt(this.$route.query.bid) || null;
      this.selectedFloorId = parseInt(this.$route.params.floorId) || null;
    },
    handleDelete(model) {
      this.deletedItem = model;
    },
    confirmDelete() {
      if (this.deletedItem) {
        const callback = () => {
          this.TablesList();
        };
        submitAndNotify(
          this,
          deleteTable({
            businessId: this.selectedBusinessId,
            branchId: this.selectedBranchId,
            floorId: this.selectedFloorId,
            id: this.deletedItem.id
          }),
          callback
        );
      }
    },
    async TablesList(page = 1) {
      if (
        !this.selectedBusinessId ||
        !this.selectedBranchId ||
        !this.selectedFloorId
      )
        return;
      const perPage = this.searchQuery
        ? this.paginationMeta.total
        : this.paginationMeta.per_page;

      return getTableData({
        businessId: this.selectedBusinessId,
        branchId: this.selectedBranchId,
        floorId: this.selectedFloorId,
        "per-page": perPage,
        page
      }).then(response => {
        this.items = response.data;
        this.paginationMeta = response.meta;
      });
    },
    editMenu(model) {
      this.showAdd = false;
      const requiredLocales = ["en", "ar"];
      this.editModel = {
        ...model,
        locales: requiredLocales.map(
          locale =>
            model.locales.find(l => l.locale === locale) || {
              locale,
              name: "",
              description: "",
              id: ""
            }
        )
      };
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler() {
        this.updateSelectedIds();
        if (
          this.selectedBusinessId &&
          this.selectedBranchId &&
          this.selectedFloorId
        ) {
          this.TablesList();
        }
      }
    },
    "$route.params.floorId": {
      immediate: true,
      handler(newFloorId) {
        if (newFloorId) {
          this.selectedFloorId = parseInt(newFloorId);
          this.TablesList();
        }
      }
    }
  }
};
</script>

<style scoped></style>
